import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

type CurrentProjectIdContextValue = {
  projectId?: string;
};

/**
 * Context for current project ID.
 */
const CurrentProjectIdContext =
  getOrCreateGlobalContext<CurrentProjectIdContextValue>(
    CONTEXT_NAMES.CurrentProjectIdContext
  );

const useCurrentProjectIdContext = () =>
  useContextWithValidation(CurrentProjectIdContext, {
    hook: 'useCurrentProjectIdContext',
    provider: 'CurrentProjectIdProvider',
  });

export const useCurrentProjectId = () => {
  const currentProjectIdContext = useCurrentProjectIdContext();
  return currentProjectIdContext?.projectId;
};

type CurrentProjectIdProviderProps = {
  projectId?: string;
  children: ReactNode;
};

export const CurrentProjectIdProvider: FC<CurrentProjectIdProviderProps> = ({
  children,
  projectId,
}) => {
  return (
    <CurrentProjectIdContext.Provider value={{ projectId }}>
      {children}
    </CurrentProjectIdContext.Provider>
  );
};

CurrentProjectIdProvider.displayName = 'CurrentProjectIdProvider';

CurrentProjectIdProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node,
  /** The project ID */
  projectId: PropTypes.string,
};
